import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturesSection from './components/FeaturesSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import { SEO } from '../../utils/seo';

const HomePage = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "AutoRental",
    "name": "대전에어렌트카",
    "description": "대전에서 가장 빠른 렌트카 예약 서비스. 소형차, 중형차, 대형차, SUV, 승합차 등 다양한 차량을 24시간 언제든지 예약하실 수 있습니다. 대전 전 지역 무료 배달 서비스 제공. 인근.세종,논산,계룡,공주가능.",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://daejeon-rentcar.com'}`,
    "telephone": "010-5437-1535",
    "image": `${import.meta.env.VITE_SITE_URL || 'https://daejeon-rentcar.com'}/logo.png`,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "신갈마로141번길10",
      "addressLocality": "서구",
      "addressRegion": "대전광역시",
      "postalCode": "35222",
      "addressCountry": "KR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "36.3504",
      "longitude": "127.3845"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    },
    "priceRange": "₩₩",
    "areaServed": [
      "대전광역시",
      "세종특별자치시",
      "충청남도 공주시",
      "충청남도 논산시",
      "충청남도 계룡시"
    ],
    "sameAs": [
      "https://blog.naver.com/air1535"
    ]
  };

  return (
    <div className="min-h-screen">
      <SEO
        title="대전렌트카 - 대전 전 지역 24시간 렌트카 서비스"
        description="대전에서 가장 빠른 렌트카 예약 서비스. 소형차, 중형차, 대형차, SUV, 승합차 등 다양한 차량을 24시간 언제든지 예약하실 수 있습니다. 대전 전 지역 무료 배달 서비스 제공. 인근.세종,논산,계룡,공주가능."
        keywords="대전렌트카, 대전소형차렌트카, 대전중형차렌트카, 대전대형차렌트카, 대전SUV렌트카, 대전승합차렌트카.세종렌트카,논산렌트카,계룡렌트카,공주렌트카"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`}
        schema={schema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturesSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
